import router from '@/router'
import { http } from '@/plugins/http'

import beforeEach from './services/router/beforeEach'
import interceptors from './services/http/interceptors'

beforeEach(router)
interceptors(http, router)



// WEBPACK FOOTER //
// ./src/app/auth/include.js